import { render } from "./tournament-statistics.vue?vue&type=template&id=76c2d56c&ts=true"
import script from "./tournament-statistics.vue?vue&type=script&lang=ts"
export * from "./tournament-statistics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Reports/tournament-statistics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76c2d56c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76c2d56c', __exports__)) {
    api.reload('76c2d56c', __exports__)
  }
  
  module.hot.accept("./tournament-statistics.vue?vue&type=template&id=76c2d56c&ts=true", () => {
    api.rerender('76c2d56c', render)
  })

}


export default __exports__